import { analyticsDashboard as TYPES } from './../action_types';
import * as Ajax from './services';
import * as ModelCreators from './../util/model_creators';
import { dateParams as dateParamsUtil } from './utilities';

const fetch = function () {
  return function (dispatch, getState) {
    if (getState().AnalyticsDashboard.Countries.meta.exhausted) return;
    if (getState().AnalyticsDashboard.Countries.meta.fetching) return;

    dispatch({
      type: TYPES.FETCH_COUNTRIES_REQUEST,
    });

    const dateParams = dateParamsUtil(
      getState().AnalyticsDashboard.DisplayedDates,
    );

    $.when(Ajax.HitsService(dateParams), Ajax.AllTimeHitsByCountryService())
      .done(function (hitsResponse, allTimeHitsByCountryResponse) {
        const countries = ModelCreators.Countries(
          hitsResponse[0].hits,
          allTimeHitsByCountryResponse[0].countries.totals,
        );

        dispatch({
          type: TYPES.FETCH_COUNTRIES_SUCCESS,
          countries: countries,
        });
      })
      .fail(function () {
        dispatch({
          type: TYPES.FETCH_COUNTRIES_FAILURE,
        });
      });
  };
};

const Countries = { fetch };
export { Countries };

const initialState = {
  models: [],
  meta: {
    exhausted: false,
    fetching: false,
    errorFetching: false,
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_COUNTRIES_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_COUNTRIES_SUCCESS:
      return Object.assign({}, state, {
        models: state.models.concat(action.countries),
        meta: Object.assign({}, state.meta, {
          fetching: false,
          exhausted: true,
          errorFetching: false,
        }),
      });

    case TYPES.FETCH_COUNTRIES_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: false,
          errorFetching: true,
        }),
      });

    case TYPES.SET_DISPLAYED_DATES:
      return initialState;

    default:
      return state;
  }
};

export { reducer, reducer as default };
